import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { DebtType, InterestRateType, ProjectionResult } from '@shared/types';

export function useDebtSchedule(debtId: number | undefined, monthlyPayment?: number) {
  return useQuery({
    queryKey: ['debts', debtId, 'schedule', monthlyPayment],
    queryFn: async () =>
      (
        await api.get<ProjectionResult>(`/debts/${debtId}/schedule`, {
          params: monthlyPayment ? { monthlyPayment } : undefined,
        })
      ).data,
    enabled: debtId != null,
  });
}

export function useDebtScenarios(debtId: number | undefined, payments: number[]) {
  return useQuery({
    queryKey: ['debts', debtId, 'scenarios', payments],
    queryFn: async () =>
      (
        await api.get<Array<{ monthlyPayment: number; result: ProjectionResult }>>(
          `/debts/${debtId}/scenarios`,
          { params: { payments: payments.join(',') } },
        )
      ).data,
    enabled: debtId != null && payments.length > 0,
  });
}

export interface FreeProjectionInput {
  type: DebtType;
  balance: number;
  interestRate: number;
  interestRateType: InterestRateType;
  termMonths?: number | null;
  installmentAmount?: number | null;
  monthlyPayment?: number;
}

export async function simulateFreeProjection(input: FreeProjectionInput): Promise<ProjectionResult> {
  return (await api.post<ProjectionResult>('/tools/projection', input)).data;
}
